var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNomoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#9c3;stroke:#fafafa;stroke-width:0.5px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-225 -1690)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(225 1690)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 89
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.25 1708.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M229.515,199.81a2.03,2.03,0,0,0-2.029,2.041v28.607H178.858a2.029,2.029,0,1,0,0,4.058H229.88c1.128,0,1.664-.923,1.664-2.051V201.851a2.03,2.03,0,0,0-2.029-2.041Z",
    transform: "translate(-164.044 -179.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M209.075,181.763V151.149a2.029,2.029,0,1,0-4.058,0v28.643H162.269l-4.085,4.058h49.19c1.128,0,1.7-.959,1.7-2.087Z",
    transform: "translate(-147.661 -135.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M292.493,221.871a9.092,9.092,0,0,0-.474-2.774l-3.7,3.7a5.1,5.1,0,0,1-4.09,4.087l-3.7,3.7a9.053,9.053,0,0,0,2.781.477,9.193,9.193,0,0,0,9.184-9.184Z",
    transform: "translate(-255.231 -196.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.474,38.956a1.994,1.994,0,1,0-2.887-2.743l-7.069,7.207h-36.9A1.794,1.794,0,0,0,71.6,45.172V75.785a2.094,2.094,0,0,0,2.019,2.124H75.8l-4.152,4.108a2.015,2.015,0,0,0,0,2.865,2.04,2.04,0,0,0,2.888-.009ZM94.121,59.516a5.106,5.106,0,0,1,4.046-4.042ZM75.653,47.477h6.124a5.9,5.9,0,0,1-6.124,5.858Zm0,9.941a10.278,10.278,0,0,0,10.206-9.941h20.573L101.876,51.9a9.039,9.039,0,0,0-2.75-.539,9.166,9.166,0,0,0-9.184,9.151,8.923,8.923,0,0,0,.469,2.728L84.632,69a10.009,10.009,0,0,0-8.979-5.465Zm0,16.434v-6.23a6.257,6.257,0,0,1,5.872,4.534l-1.645,1.7Z",
    transform: "translate(-71.045 -35.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M243.543,104.859v5.858a6.046,6.046,0,0,1-5.739-4.509l-3.182,3.109a10.726,10.726,0,0,0,8.921,5.482v6.122a9.926,9.926,0,0,0-9.925,10.312H213.009l-4.085,4.058h36.94c1.128,0,1.737-1,1.737-2.125V102.554a1.571,1.571,0,0,0-1.736-1.752h-2.218l-4.084,4.058Zm0,26.374H237.7a5.983,5.983,0,0,1,5.843-6.23Z",
    transform: "translate(-192.274 -92.921)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomoney);
export default __webpack_public_path__ + "static/media/nomoney.1a505a2695f9596a275a3a34f75c732b.svg";
export { ForwardRef as ReactComponent };